<template>
  <div
    ref="trustbox"
    class="trustpilot-widget mb-5"
    data-locale="en-US"
    data-template-id="56278e9abfbbba0bdcd568bc"
    data-businessunit-id="5d68312aef620200012de4d6"
    data-style-height="58px"
    data-style-width="100%"
    data-theme="light"
  >
    <a
      href="https://uk.trustpilot.com/review/guiide.co.uk"
      target="_blank"
      rel="noopener"
      >Trustpilot</a
    >
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { ensureScriptLoaded } from '@/guiide/ts/utilities';

const trustbox = ref(null);

onMounted(() => {
  ensureScriptLoaded('https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', () => {
    ;(window as any).Trustpilot?.loadFromElement(trustbox.value);
  });
});
</script>